import { it } from 'date-fns/locale/it';
import { useEffect, useState } from "react";
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useAppDispatch, useAppSelector } from '../../../lib/redux/hooks';
import { colors } from '../../../ui/colors';
import { EditIcon } from '../../../ui/icons/edit';
import { TrashIcon } from '../../../ui/icons/trash';
import { UsersO1Icon } from '../../../ui/icons/users01';
import { ButtonComponent } from "../../../ui/molecules/button/newButton";
import { RappLegalePopup } from "../../../ui/molecules/rappLegalePopup";
import { Dropdown } from '../../../ui/organisms/dropdown';
import { ErrorPopup } from '../../../ui/organisms/errorPopup';
import { SuccessPopup } from '../../../ui/organisms/successPopup';
import { formatterDate } from '../../../utils';
import { getLegalRepresentativeById, getLegalRepresentativeByIds, resetLegalRepresentativeCreateErrors, resetLegalRepresentativeCreateRequest, resetLegalRepresentativeUpdateRequest, setDeleteLegalRepresentativeStatus, setLegalRepresentativeCreateRequestField, setLegalRepresentativeCreateStatus, setLegalRepresentativeUpdateRequest, setLegalRepresentativeUpdateStatus } from '../feature/legalRepresentative/slice';
import { RemoveLegalRepresentativeModal } from './removeLegalRepresentativeModal';

registerLocale('it', it)

const COL_HEADERS = [
    'Codice Fiscale', 'Cognome', 'Nome', 'Data di Nascita',
    'Indirizzo', 'CAP', 'Comune', 'Provincia',
    'Data Ingresso', 'Data Uscita', '',
]

export function BoxRappLegaleEdit() {
    const customerState = useAppSelector(state => state.customer)
    const legalRapresentativeState = useAppSelector(state => state.legalRapresentative)
    const dispatch = useAppDispatch()

    const [popupOpen, setPopupOpen] = useState(false)
    const [mode, setMode] = useState<'create' | 'edit'>('create')
    const [disableButton, setDisableButton] = useState(false)
    const [showDeletePopup, setShowDeletePopup] = useState(false)
    const [selectedDeleteId, setSelectedDeleteId] = useState<string | undefined>(undefined)

    // const voidRappLeg: GetRapplegaleByIdDTO = {
    //     userId: usersState.selectedUserId,
    //     fiscalCode: '', surname: '', name: '', sex: '',
    //     birthdate: new Date(), state: 'IT',
    //     countryRegion: '', province: '', city: '',
    //     contactAddress: '', contactCountryRegion: '',
    //     contactProvince: '', contactCity: '', contactZipCode: '',
    //     phone: '', mobilePhone: '', email: '', fax: '',
    //     note: '', activationDate: new Date(),
    // }

    useEffect(() => {
        if (customerState.getCustomerByIdStatus === "successfully" && customerState.getCustomerByIdResponse !== undefined) {
            dispatch(setLegalRepresentativeCreateRequestField({ field: "customerId", value: customerState.getCustomerByIdResponse.id }))
            if (customerState.getCustomerByIdResponse.legalRepresentativeIds && customerState.getCustomerByIdResponse.legalRepresentativeIds.length > 0)
                dispatch(getLegalRepresentativeByIds(customerState.getCustomerByIdResponse.legalRepresentativeIds))
            else
                setDisableButton(false)
        }
    }, [customerState.getCustomerByIdStatus, legalRapresentativeState.removeLegalRepresentativeStatus])

    useEffect(() => {
        const legalRepresentatives = legalRapresentativeState.getLegalRepresentativeByIdsResponse
        setDisableButton(!!legalRepresentatives?.some((legal) => legal.active))
    }, [legalRapresentativeState.getLegalRepresentativeByIdsResponse])

    // useEffect(() => {
    //     if (clientiState.GetRappLegaleByIdResponseStatus === 'successfully') {
    //         dispatch(resetGetRappLegaleByIdStatus())
    //         if (clientiState.GetRappLegaleByIdResponse !== undefined) {
    //             if (clientiState.GetRappLegaleByIdResponse.active) setDisableButton(true)
    //             dispatch(addEditLegalRapp(clientiState.GetRappLegaleByIdResponse))
    //         }
    //     }
    // }, [clientiState.GetRappLegaleByIdResponseStatus])

    // useEffect(() => {
    //     if (clientiState.GetAllRappLegaleStatus === 'successfully' &&
    //         clientiState.GetAllRappLegaleResponse !== undefined
    //     ) {
    //         for (const l of clientiState.GetAllRappLegaleResponse.data) {
    //             if (l.userId === usersState.selectedUserId) {
    //                 dispatch(addEditLegalRapp(l))
    //                 setDisableButton(!!l.active)
    //             }
    //         }
    //     }
    // }, [clientiState.GetAllRappLegaleStatus])

    // useEffect(() => {
    //     if (clientiState.rappLegaleUpdateStatus === 'successfully') {
    //         dispatch(resetUpdateRappLegaleStatus())
    //         dispatch(resetCreateEditRapprLegale())
    //         dispatch(setEditLegalRapp([]))
    //         dispatch(GetAllRappLegale())
    //     }
    // }, [clientiState.rappLegaleUpdateStatus])

    // useEffect(() => {
    //     if (clientiState.rappLegaleCreateResponseStatus === 'successfully') {
    //         dispatch(resetCreateRappLegaleStatus('idle'))
    //         dispatch(resetCreateEditRapprLegale())
    //         dispatch(setEditLegalRapp([]))
    //         dispatch(GetAllRappLegale())
    //     }
    // }, [clientiState.rappLegaleCreateResponseStatus])

    // useEffect(() => {
    //     if (clientiState.rappLegaleDeactivateStatus === 'successfully') {
    //         dispatch(setEditLegalRapp([]))
    //         dispatch(GetAllRappLegale())
    //     }
    // }, [clientiState.rappLegaleDeactivateStatus])

    return (
        <div className="p-6 flex flex-col gap-6">
            {
                popupOpen &&
                <RappLegalePopup
                    closeHandler={() => setPopupOpen(false)}
                    mode={mode}
                    customerId={customerState.getCustomerByIdResponse?.id!}
                />
            }
            {legalRapresentativeState.legalRepresentativeCreateStatus === "successfully" || legalRapresentativeState.legalRepresentativeUpdateStatus === "successfully" || legalRapresentativeState.deleteLegalRepresentativeStatus === "successfully" ?
                <div className="px-6 pt-3 pb-1 flex flex-col gap-2">
                    <SuccessPopup
                        active={legalRapresentativeState.legalRepresentativeCreateStatus === "successfully" || legalRapresentativeState.legalRepresentativeUpdateStatus === "successfully" || legalRapresentativeState.deleteLegalRepresentativeStatus === "successfully"}
                        message="Dati salvati correttamente."
                        onClose={() => {
                            dispatch(setLegalRepresentativeCreateStatus("idle"))
                            dispatch(setLegalRepresentativeUpdateStatus("idle"))
                            dispatch(setDeleteLegalRepresentativeStatus("idle"))
                        }}
                    />
                </div>
                : legalRapresentativeState.legalRepresentativeCreateStatus === "failed" || legalRapresentativeState.legalRepresentativeUpdateStatus === "failed" ?
                    <div className="px-6 pt-3 pb-1 flex flex-col gap-2">
                        <ErrorPopup
                            active={legalRapresentativeState.legalRepresentativeCreateStatus === "failed" || legalRapresentativeState.legalRepresentativeUpdateStatus === "failed"}
                            message="Si è verificato un errore durante la modifica del rappresentante legale."
                            onClose={() => {
                                dispatch(setLegalRepresentativeCreateStatus("idle"))
                                dispatch(setLegalRepresentativeUpdateStatus("idle"))
                                dispatch(setDeleteLegalRepresentativeStatus("idle"))
                            }}
                        />
                    </div> : null
            }
            {
                legalRapresentativeState.getLegalRepresentativeByIdsResponse === undefined || legalRapresentativeState.getLegalRepresentativeByIdsResponse.length === 0 ? (
                    <div className="flex flex-col items-center justify-center py-12 text-center">
                        <div className="w-12 h-12 rounded-full bg-brandPrimary-100 flex items-center justify-center mb-3">
                            <UsersO1Icon size={20} color={colors.brandPrimary[500]} />
                        </div>
                        <p className="font-['Manrope'] text-sm font-semibold text-neutral-600">
                            Nessun rappresentante legale
                        </p>
                        <p className="font-['Manrope'] text-xs text-neutral-400 mt-1">
                            Aggiungi il primo rappresentante usando il pulsante in basso.
                        </p>
                    </div>
                ) : (
                    <div className="w-full max-w-full min-w-0 rounded-t-2xl border border-neutral-200 bg-white shadow-sm overflow-hidden">
                        <div className="w-full max-w-full overflow-x-auto">
                            <div className="max-h-[420px] overflow-y-auto">
                                <table className="w-max min-w-full table-auto border-separate border-spacing-0 font-['Manrope'] text-sm">
                                    <thead className="sticky top-0 z-20">
                                        <tr className="bg-brandPrimary-600 text-white">
                                            {COL_HEADERS.map((h, i) => (
                                                <th
                                                    key={i}
                                                    className={`px-4 py-4 text-left text-xs font-semibold uppercase tracking-wide whitespace-nowrap ${i === COL_HEADERS.length - 1 ? 'w-16' : ''}`}
                                                >
                                                    {h}
                                                </th>
                                            ))}
                                        </tr>
                                    </thead>
                                    <tbody className="divide-y divide-neutral-100">
                                        {legalRapresentativeState.getLegalRepresentativeByIdsResponse?.map((legal, index) => (
                                            <tr
                                                key={legal.id}
                                                className={[
                                                    'transition-colors duration-150 align-middle',
                                                    index % 2 === 0 ? 'bg-white' : 'bg-neutral-50',
                                                    'hover:bg-brandPrimary-25',
                                                ].join(' ')}
                                            >
                                                {[
                                                    legal.fiscalCode,
                                                    legal.surname,
                                                    legal.name,
                                                    formatterDate(legal.birthdate),
                                                    legal.contactAddress,
                                                    legal.contactZipCode,
                                                    legal.city,
                                                    legal.province,
                                                    formatterDate(legal.activationDate),
                                                    formatterDate(legal.deactivationDate),
                                                ].map((val, ci) => (
                                                    <td
                                                        key={ci}
                                                        className="px-4 py-4 text-neutral-700 font-medium whitespace-nowrap text-left"
                                                        title={typeof val === 'string' ? val : undefined}
                                                    >
                                                        {val || <span className="text-neutral-300">—</span>}
                                                    </td>
                                                ))}
                                                <td className="px-3 py-4">
                                                    <Dropdown portaled items={legal.active ? [
                                                        {
                                                            label: 'Modifica',
                                                            icon: <EditIcon color="" size={0} />,
                                                            onClick: () => {
                                                                dispatch(getLegalRepresentativeById(legal.id))
                                                                    .unwrap()
                                                                    .then((response) => {
                                                                        dispatch(setLegalRepresentativeUpdateRequest(response))
                                                                        dispatch(resetLegalRepresentativeCreateErrors())
                                                                        setMode("edit")
                                                                        setPopupOpen(true)
                                                                    })
                                                                    .catch(() => { })
                                                            },
                                                        },
                                                        {
                                                            label: 'Disattiva',
                                                            icon: <TrashIcon color="" size={0} />,
                                                            onClick: () => {
                                                                setSelectedDeleteId(legal.id)
                                                                setShowDeletePopup(true)
                                                            },
                                                        },
                                                    ] : [
                                                        {
                                                            label: 'Modifica',
                                                            icon: <EditIcon color="" size={0} />,
                                                            onClick: () => {
                                                                dispatch(getLegalRepresentativeById(legal.id))
                                                                    .unwrap()
                                                                    .then((response) => {
                                                                        dispatch(setLegalRepresentativeUpdateRequest(response))
                                                                        dispatch(resetLegalRepresentativeCreateErrors())
                                                                        setMode("edit")
                                                                        setPopupOpen(true)
                                                                    })
                                                                    .catch(() => { })
                                                            },
                                                        },
                                                    ]} />
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                )}
            <div>
                <ButtonComponent
                    disabled={disableButton}
                    size="sm"
                    iconPosition="off"
                    variant="outline"
                    color="blue"
                    label="Aggiungi Rappresentante Legale"
                    onClick={() => {
                        dispatch(resetLegalRepresentativeCreateRequest())
                        dispatch(resetLegalRepresentativeUpdateRequest())
                        dispatch(resetLegalRepresentativeCreateErrors())
                        setMode("create")
                        setPopupOpen(true)
                    }}
                />
            </div>
            <RemoveLegalRepresentativeModal
                visible={showDeletePopup}
                id={selectedDeleteId}
                onClose={() => {
                    setShowDeletePopup(false)
                    setSelectedDeleteId(undefined)
                }}
            />
        </div>
    )
}